/**
 * ChantMusicGate — keeps the vielle.mp3 loop playing on the
 * /games/peoples-chant route and stops it the moment the visitor
 * navigates away.  Mounted once at the App root.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { startChantMusic, stopChantMusic } from "@/lib/chantMusic";

export default function ChantMusicGate() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/games/peoples-chant")) {
      startChantMusic();
    } else {
      stopChantMusic();
    }
  }, [pathname]);
  useEffect(() => () => stopChantMusic(), []);
  return null;
}
